const defaultConfig = {
  style: 'currency',
  currency: 'BRL',
  currencyDisplay: 'symbol',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};

export function moneyFormat(value, locale = 'pt-br', configs = defaultConfig) {
  let aux = 0;
  if (value) {
    aux = value;
  }
  if (aux instanceof String) {
    aux = Number(aux);
  }
  return aux.toLocaleString(locale, configs);
}

/*
  calculo dos dedutore baseado no site
  https://www.tributa.net/nova-tabela-de-inss-2021-com-parcelas-a-deduzir
*/
const calculoDedutores = (tabelaInss) => {
  if (tabelaInss.length > 0) {
    const faixa1 = tabelaInss[0];
    const faixa2 = tabelaInss[1];
    const faixa3 = tabelaInss[2];
    const faixa4 = tabelaInss[3];
    const valoresFaixas = [0];
    const resultadoPorcentagemFaixa2 = faixa2.calculo - faixa1.calculo;
    const valorDedutorFaixa2 = faixa1.valor * resultadoPorcentagemFaixa2;
    valoresFaixas.push(valorDedutorFaixa2);
    const resultadoPorcentagemFaixa3 = faixa3.calculo - faixa2.calculo;
    const valorDedutorFaixa3 = faixa2.valor * resultadoPorcentagemFaixa3;
    valoresFaixas.push(valorDedutorFaixa3 + valorDedutorFaixa2);
    const resultadoPorcentagemFaixa4 = faixa4.calculo - faixa3.calculo;
    const valorDedutorFaixa4 = faixa3.valor * resultadoPorcentagemFaixa4;
    valoresFaixas.push(
      valorDedutorFaixa4 + valorDedutorFaixa2 + valorDedutorFaixa3
    );
    return valoresFaixas;
  }
  return [];
};

const calcFaixaDedutorColab = (tabelaInss, salario) => {
  let valorFaixaAnterior = 0;
  const valoresFaixas = calculoDedutores(tabelaInss);
  let valorFaixaColaborador = 0;
  tabelaInss.forEach((item, index) => {
    const faixaAtual = item.valor || 0;
    if (salario > valorFaixaAnterior && salario <= faixaAtual) {
      valorFaixaColaborador = valoresFaixas[index];
    }
    valorFaixaAnterior = parseFloat(faixaAtual);
  });
  return valorFaixaColaborador;
};

/**
 * Calcula desconto do INSS
 * @param tetoDesconto - valor maximo para desconto do INSS
 * @param tabelaInss - tabela para calcular o desconto de INSS
 * @param salario - valor do salari oque sera aplicado o calculo
 * @returns {number}Retorna o valor para desconto de INSS
 */
export const descontoInss = (tetoDesconto, tabelaInss, salario) => {
  let desconto = 0;
  if (tabelaInss && tabelaInss.length > 0) {
    let valorFaixaAnterior = 0;
    const teto = parseFloat(tetoDesconto);
    let deducao = calcFaixaDedutorColab(tabelaInss, salario);
    tabelaInss.forEach((item) => {
      const faixaAtual = item.valor || 0;
      const porcentagem = item.calculo || 0;

      if (item.subtracao !== undefined && item.subtracao !== null) {
        deducao = item.subtracao;
      }

      if (salario > valorFaixaAnterior && salario <= faixaAtual) {
        desconto = salario * porcentagem - deducao;
      }
      valorFaixaAnterior = parseFloat(faixaAtual);
    });
    return desconto > teto ? teto : desconto;
  }
  return 0;
};

export const calculoDedutor = (tabelaInss, salario) =>
  calcFaixaDedutorColab(tabelaInss, salario);

export const calculoFaixasDedutor = (tabelaInss) =>
  calculoDedutores(tabelaInss);

export const arredondar = (valor) => Math.trunc(valor * 100) / 100;
